import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f84ba82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-page" }
const _hoisted_2 = {
  class: "flex gap-cell",
  style: { left: '22px', top: '12px' }
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" add emoji ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex p-sub gap-mention sub rounded-mention self-start opacity-0" }, " _ ", -1))
const _hoisted_5 = { class: "flex gap-cell" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center clickable rounded-mention",
  style: { width: '67px', height: '67px' }
}
const _hoisted_7 = { class: "flex flex-col flex-grow relative" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg-paper py-8 relative",
  style: { 'z-index': '3' }
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.cover != null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cover absolute",
          style: _normalizeStyle({
        'background-image': `url(${_ctx.cover})`,
        'background-size': 'cover',
        height: '360px',
        top: 0,
      })
        }, null, 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: _normalizeStyle({ 'padding-top': _ctx.cover == null ? '85px' : '320px' })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col gap-cell bg-paper rounded-t-12 relative fountain-width mx-auto px-content py-cell", { 'shadow-base': _ctx.cover != null }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx._icon.length == 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "flex p-sub gap-mention sub rounded-mention clickable self-start",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addEmoji && _ctx.addEmoji(...args)))
              }, [
                _createVNode(_component_Icon, {
                  icon: ['fal', 'plus-square'],
                  class: "icon-sm"
                }),
                _hoisted_3
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "flex p-sub gap-mention sub rounded-mention clickable self-start",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addCover && _ctx.addCover(...args)))
          }, [
            _createVNode(_component_Icon, {
              icon: ['fal', 'plus-square'],
              class: "icon-sm"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.cover == null ? "add cover" : "change cover") + " ", 1),
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.storeFile && _ctx.storeFile(...args))),
              class: "hidden",
              ref: "coverInput",
              accept: ".png, .jpg, .jpeg, .svg"
            }, null, 544)
          ]),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx._icon.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "text-h1",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openEmojiSelect && _ctx.openEmojiSelect(...args)))
                }, _toDisplayString(_ctx._icon), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "text-h1 tracking-h1 leading-h1",
              placeholder: "name",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx._name) = $event)),
              onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveName && _ctx.saveName(...args)))
            }, null, 544), [
              [_vModelText, _ctx._name]
            ])
          ])
        ])
      ], 2),
      _hoisted_8
    ], 4)
  ]))
}